// 全站统一错误码
// https://km.sankuai.com/collabpage/1701608092

// 账号未登录，无token等，passport/sso校验结果
// 401~406都表示未登录
const LOGIN_ERROR_401 = 401
const LOGIN_ERROR_402 = 402
const LOGIN_ERROR_403 = 403
const LOGIN_ERROR_404 = 404
const LOGIN_ERROR_405 = 405
const LOGIN_ERROR_406 = 406

// 账号未登录，无token等，shepherd校验无token
const LOGIN_ERROR_SSO_NOTOKEN = 50102


// 直接跳登录页到的处理（不刷新页面，不重新登录的情况都直接跳登录）。
// 其他情况可透传给业务代码，自行弹窗。
const LOGIN_ERROR_CODES = [
  LOGIN_ERROR_401,
  LOGIN_ERROR_402,
  LOGIN_ERROR_403,
  LOGIN_ERROR_404,
  LOGIN_ERROR_405,
  LOGIN_ERROR_406,
  LOGIN_ERROR_SSO_NOTOKEN,
]


export {
  LOGIN_ERROR_401,
  LOGIN_ERROR_402,
  LOGIN_ERROR_403,
  LOGIN_ERROR_404,
  LOGIN_ERROR_405,
  LOGIN_ERROR_406,
  LOGIN_ERROR_SSO_NOTOKEN,
  LOGIN_ERROR_CODES,
}
